import { z } from 'zod'

/**
 * Contrato da integração Via Processos → Via Tax (docs/integracao-processos.md).
 *
 * Os campos espelham `clients` do Processos (drizzle/schema.ts de lá). Nada é
 * confiado sem passar por aqui: o Processos é fonte da verdade do cadastro, não
 * da forma do dado.
 */

export const TAX_REGIMES_PROCESSOS = [
  'simples_nacional',
  'lucro_presumido',
  'lucro_real',
  'domesticas',
  'isentas',
  'pessoa_fisica_rural',
  'pessoa_fisica_empregador',
  'simples_nacional_fator_r',
  'condominios',
  'mei',
  'pessoa_fisica',
] as const

export const ClienteProcessos = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
  tradingName: z.string().nullable().optional(),
  document: z.string().min(1),
  documentType: z.enum(['cnpj', 'cpf', 'caepf']),
  status: z.enum(['constitution', 'onboarding', 'active', 'inactive']),
  // Enum aberto: valor novo do Processos não pode derrubar a sincronização
  // inteira — vira "regime não mapeado" e segue.
  taxRegime: z.string().nullable().optional(),
  businessArea: z.string().nullable().optional(),
  stateRegistration: z.string().nullable().optional(),
  municipalRegistration: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  state: z.string().nullable().optional(),
  responsavel: z.object({ id: z.number().int(), nome: z.string() }).nullable().optional(),
  updatedAt: z.string().datetime({ offset: true }),
})
export type ClienteProcessos = z.infer<typeof ClienteProcessos>

export const PaginaClientesProcessos = z.object({
  itens: z.array(ClienteProcessos),
  proximoCursor: z.string().nullable(),
})
export type PaginaClientesProcessos = z.infer<typeof PaginaClientesProcessos>

/**
 * Corpo do webhook. Carrega só o id: o worker busca o registro no Processos
 * antes de gravar. Assim um webhook atrasado (chegando depois de outro mais
 * novo) nunca rebobina o espelho para um estado antigo.
 */
export const WebhookProcessos = z.object({
  evento: z.enum(['cliente.criado', 'cliente.atualizado']),
  clienteId: z.number().int().positive(),
  ocorridoEm: z.string().datetime({ offset: true }),
})
export type WebhookProcessos = z.infer<typeof WebhookProcessos>

export const CABECALHOS_WEBHOOK_PROCESSOS = {
  assinatura: 'x-processos-signature',
  timestamp: 'x-processos-timestamp',
  eventoId: 'x-processos-event-id',
} as const
